module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./~/markdown-it-regexp/index.js
// module id = 133
// module chunks = 0